<script lang="ts">
  import type { HTMLAttributes } from 'vue'

  export interface DataListLeadingProps {
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import { cn } from '@gat-ship/vue-components'
  const props = defineProps<DataListLeadingProps>()
</script>

<template>
  <div :class="cn('flex shrink-0 items-center justify-center', props.class)">
    <slot />
  </div>
</template>
